module.exports = __webpack_public_path__ + "img/sleeve flounce opening.e2674fae.png";